/* Auto-generated. Do not edit manually. */
import { ReactComponent as Block_1_25 } from "../blocks/1/land_plot_block_25.svg";
import { ReactComponent as Block_1_26 } from "../blocks/1/land_plot_block_26.svg";
import { ReactComponent as Block_1_27 } from "../blocks/1/land_plot_block_27.svg";
import { ReactComponent as Block_1_28 } from "../blocks/1/land_plot_block_28.svg";
import { ReactComponent as Block_1_29 } from "../blocks/1/land_plot_block_29.svg";
import { ReactComponent as Block_1_30 } from "../blocks/1/land_plot_block_30.svg";
import { ReactComponent as Block_1_31 } from "../blocks/1/land_plot_block_31.svg";
import { ReactComponent as Block_1_32 } from "../blocks/1/land_plot_block_32.svg";
import { ReactComponent as Block_1_33 } from "../blocks/1/land_plot_block_33.svg";
import { ReactComponent as Block_1_34 } from "../blocks/1/land_plot_block_34.svg";
import { ReactComponent as Block_1_35 } from "../blocks/1/land_plot_block_35.svg";
import { ReactComponent as Block_1_36 } from "../blocks/1/land_plot_block_36.svg";
import { ReactComponent as Block_1_37 } from "../blocks/1/land_plot_block_37.svg";
import { ReactComponent as Block_1_5 } from "../blocks/1/land_plot_block_5.svg";
import { ReactComponent as Block_30_25 } from "../blocks/30/land_plot_block_25.svg";
import { ReactComponent as Block_30_26 } from "../blocks/30/land_plot_block_26.svg";
import { ReactComponent as Block_30_27 } from "../blocks/30/land_plot_block_27.svg";
import { ReactComponent as Block_30_28 } from "../blocks/30/land_plot_block_28.svg";
import { ReactComponent as Block_30_29 } from "../blocks/30/land_plot_block_29.svg";
import { ReactComponent as Block_30_30 } from "../blocks/30/land_plot_block_30.svg";
import { ReactComponent as Block_30_31 } from "../blocks/30/land_plot_block_31.svg";
import { ReactComponent as Block_30_32 } from "../blocks/30/land_plot_block_32.svg";
import { ReactComponent as Block_30_33 } from "../blocks/30/land_plot_block_33.svg";
import { ReactComponent as Block_30_34 } from "../blocks/30/land_plot_block_34.svg";
import { ReactComponent as Block_30_35 } from "../blocks/30/land_plot_block_35.svg";
import { ReactComponent as Block_30_36 } from "../blocks/30/land_plot_block_36.svg";
import { ReactComponent as Block_30_37 } from "../blocks/30/land_plot_block_37.svg";
import { ReactComponent as Block_30_5 } from "../blocks/30/land_plot_block_5.svg";
import { ReactComponent as Block_60_25 } from "../blocks/60/land_plot_block_25.svg";
import { ReactComponent as Block_60_26 } from "../blocks/60/land_plot_block_26.svg";
import { ReactComponent as Block_60_27 } from "../blocks/60/land_plot_block_27.svg";
import { ReactComponent as Block_60_28 } from "../blocks/60/land_plot_block_28.svg";
import { ReactComponent as Block_60_29 } from "../blocks/60/land_plot_block_29.svg";
import { ReactComponent as Block_60_30 } from "../blocks/60/land_plot_block_30.svg";
import { ReactComponent as Block_60_31 } from "../blocks/60/land_plot_block_31.svg";
import { ReactComponent as Block_60_32 } from "../blocks/60/land_plot_block_32.svg";
import { ReactComponent as Block_60_33 } from "../blocks/60/land_plot_block_33.svg";
import { ReactComponent as Block_60_34 } from "../blocks/60/land_plot_block_34.svg";
import { ReactComponent as Block_60_35 } from "../blocks/60/land_plot_block_35.svg";
import { ReactComponent as Block_60_36 } from "../blocks/60/land_plot_block_36.svg";
import { ReactComponent as Block_60_37 } from "../blocks/60/land_plot_block_37.svg";
import { ReactComponent as Block_60_5 } from "../blocks/60/land_plot_block_5.svg";
import { ReactComponent as Block_92_25 } from "../blocks/92/land_plot_block_25.svg";
import { ReactComponent as Block_92_26 } from "../blocks/92/land_plot_block_26.svg";
import { ReactComponent as Block_92_27 } from "../blocks/92/land_plot_block_27.svg";
import { ReactComponent as Block_92_28 } from "../blocks/92/land_plot_block_28.svg";
import { ReactComponent as Block_92_29 } from "../blocks/92/land_plot_block_29.svg";
import { ReactComponent as Block_92_30 } from "../blocks/92/land_plot_block_30.svg";
import { ReactComponent as Block_92_31 } from "../blocks/92/land_plot_block_31.svg";
import { ReactComponent as Block_92_32 } from "../blocks/92/land_plot_block_32.svg";
import { ReactComponent as Block_92_33 } from "../blocks/92/land_plot_block_33.svg";
import { ReactComponent as Block_92_34 } from "../blocks/92/land_plot_block_34.svg";
import { ReactComponent as Block_92_35 } from "../blocks/92/land_plot_block_35.svg";
import { ReactComponent as Block_92_36 } from "../blocks/92/land_plot_block_36.svg";
import { ReactComponent as Block_92_37 } from "../blocks/92/land_plot_block_37.svg";
import { ReactComponent as Block_92_5 } from "../blocks/92/land_plot_block_5.svg";

export const zone4_block_polygons = [
    {
        wrapperIndex: 2,
        areas: [
            {
                blockIndex: 5,
                Polygon: Block_1_5,
            },
            {
                blockIndex: 25,
                Polygon: Block_1_25,
            },
            {
                blockIndex: 26,
                Polygon: Block_1_26,
            },
            {
                blockIndex: 27,
                Polygon: Block_1_27,
            },
            {
                blockIndex: 28,
                Polygon: Block_1_28,
            },
            {
                blockIndex: 29,
                Polygon: Block_1_29,
            },
            {
                blockIndex: 30,
                Polygon: Block_1_30,
            },
            {
                blockIndex: 31,
                Polygon: Block_1_31,
            },
            {
                blockIndex: 32,
                Polygon: Block_1_32,
            },
            {
                blockIndex: 33,
                Polygon: Block_1_33,
            },
            {
                blockIndex: 34,
                Polygon: Block_1_34,
            },
            {
                blockIndex: 35,
                Polygon: Block_1_35,
            },
            {
                blockIndex: 36,
                Polygon: Block_1_36,
            },
            {
                blockIndex: 37,
                Polygon: Block_1_37,
            },
        ],
    },
    {
        wrapperIndex: 31,
        areas: [
            {
                blockIndex: 5,
                Polygon: Block_30_5,
            },
            {
                blockIndex: 25,
                Polygon: Block_30_25,
            },
            {
                blockIndex: 26,
                Polygon: Block_30_26,
            },
            {
                blockIndex: 27,
                Polygon: Block_30_27,
            },
            {
                blockIndex: 28,
                Polygon: Block_30_28,
            },
            {
                blockIndex: 29,
                Polygon: Block_30_29,
            },
            {
                blockIndex: 30,
                Polygon: Block_30_30,
            },
            {
                blockIndex: 31,
                Polygon: Block_30_31,
            },
            {
                blockIndex: 32,
                Polygon: Block_30_32,
            },
            {
                blockIndex: 33,
                Polygon: Block_30_33,
            },
            {
                blockIndex: 34,
                Polygon: Block_30_34,
            },
            {
                blockIndex: 35,
                Polygon: Block_30_35,
            },
            {
                blockIndex: 36,
                Polygon: Block_30_36,
            },
            {
                blockIndex: 37,
                Polygon: Block_30_37,
            },
        ],
    },
    {
        wrapperIndex: 61,
        areas: [
            {
                blockIndex: 5,
                Polygon: Block_60_5,
            },
            {
                blockIndex: 25,
                Polygon: Block_60_25,
            },
            {
                blockIndex: 26,
                Polygon: Block_60_26,
            },
            {
                blockIndex: 27,
                Polygon: Block_60_27,
            },
            {
                blockIndex: 28,
                Polygon: Block_60_28,
            },
            {
                blockIndex: 29,
                Polygon: Block_60_29,
            },
            {
                blockIndex: 30,
                Polygon: Block_60_30,
            },
            {
                blockIndex: 31,
                Polygon: Block_60_31,
            },
            {
                blockIndex: 32,
                Polygon: Block_60_32,
            },
            {
                blockIndex: 33,
                Polygon: Block_60_33,
            },
            {
                blockIndex: 34,
                Polygon: Block_60_34,
            },
            {
                blockIndex: 35,
                Polygon: Block_60_35,
            },
            {
                blockIndex: 36,
                Polygon: Block_60_36,
            },
            {
                blockIndex: 37,
                Polygon: Block_60_37,
            },
        ],
    },
    {
        wrapperIndex: 93,
        areas: [
            {
                blockIndex: 5,
                Polygon: Block_92_5,
            },
            {
                blockIndex: 25,
                Polygon: Block_92_25,
            },
            {
                blockIndex: 26,
                Polygon: Block_92_26,
            },
            {
                blockIndex: 27,
                Polygon: Block_92_27,
            },
            {
                blockIndex: 28,
                Polygon: Block_92_28,
            },
            {
                blockIndex: 29,
                Polygon: Block_92_29,
            },
            {
                blockIndex: 30,
                Polygon: Block_92_30,
            },
            {
                blockIndex: 31,
                Polygon: Block_92_31,
            },
            {
                blockIndex: 32,
                Polygon: Block_92_32,
            },
            {
                blockIndex: 33,
                Polygon: Block_92_33,
            },
            {
                blockIndex: 34,
                Polygon: Block_92_34,
            },
            {
                blockIndex: 35,
                Polygon: Block_92_35,
            },
            {
                blockIndex: 36,
                Polygon: Block_92_36,
            },
            {
                blockIndex: 37,
                Polygon: Block_92_37,
            },
        ],
    },
];